import React from "react";
import { Link } from "react-router-dom";
import bg5 from "../../assets/images/background/bg-5.png";
import bg6 from "../../assets/images/background/bg-6.png";
import toronto from "../../assets/images/resource/toronto.png";
import paris from "../../assets/images/resource/paris.png";
import dubai from "../../assets/images/resource/dubai.png";
import ny from "../../assets/images/resource/ny.png";
import Bredcom from "../Bredcrumb/Main";
import Img from "../../assets/images/background/banner-image-3.jpg";

const SisterConcern = () => {
  return (
    <>
      <Bredcom subtitle="Sister Concern" title="BOOK YOUR TABLE" Img={Img} />
      <section className="online-reservation inner-page">
        <div className="left-bg">
          <img src={bg5} alt="" title="" />
        </div>
        <div className="right-bg">
          <img src={bg6} alt="" title="" />
        </div>

        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle">
              <span>Our Sister Concerns</span>
            </div>
            <div className="pattern-image">
              <img src="images/icons/separator.svg" alt="" title="" />
            </div>
            <h2>Book A Table</h2>
            <div className="text desc">
              Restaurant will be open for all days, Sunday night will be closed,
              All booking payment is secured with credit card, no charges will
              be aplly for online booking. no refundable.
            </div>
            <div className="text request-info">
              Booking request <Link href="#"> 01755636335</Link> or fill out the
              order form
            </div>
          </div>
        </div>

        <div className="location-center">
          <div className="auto-container">
            <div className="row clearfix">
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Xinxian Restaurant, Uttara</h4>
                  <div className="text">
                    House No. 1, Road No. 8, Sector-1, Uttara Model Town,
                    Dhaka-1230 <br />
                    Call: 01755636266, 0248958051
                    <br />
                    Web: xinxian-uttara.x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Xiamen Restaurant, Dhanmondi</h4>
                  <div className="text">
                    House No. 55 A, Road No. 4 A (New), Satmasjid Road
                    Dhanmondi, Dhaka-1209. <br />
                    Call: +8801755636260, +88 02 58617163
                    <br />
                    Mail: xiamen@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Golden Chimney Restaurant, Banglamotor</h4>
                  <div className="text">
                    80/14/A Mymensingh Road (old), Sonargaon Road (new) 12,
                    Sonartori Tower, Dhaka-1000
                    <br />
                    Call: 01755636261, 02223363969
                    <br />
                    Mail: golden.chm@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Xindian Restaurant, Dhanmondi</h4>
                  <div className="text">
                    House no. 55, 55/A (new), 273 (old) Road no. 16 (new), 27
                    (old) Dhanmondi, Dhaka -1209
                    <br />
                    0258150396, 01755636262
                    <br />
                    xindian@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Xinxian Restaurant, Dhanmondi</h4>
                  <div className="text">
                    House no. 7, Road no. 8 Dhanmondi, Dhaka -1205
                    <br />
                    01755636263, 04478778843
                    <br />
                    xinxian.dhan@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Four Seasons Restaurant, Dhanmondi</h4>
                  <div className="text">
                    House No. 59 A, Road No. 16 (new), 27 (old) Satmasjid Road,
                    Dhanmondi, Dhaka-1209
                    <br />
                    01755636264, 0241020520_21
                    <br />
                    4seasons@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Xinxian Restaurant, Mirpur-10</h4>
                  <div className="text">
                    6/C, 8/11, Mirpur-11, Dhaka
                    <br />
                    01755636265, 0248032146
                    <br />
                    xinxian.mirpur@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Chung Wah Restaurant, Bijoy Nagor</h4>
                  <div className="text">
                    203, Shaheed Syed Nazrul Islam Sarani, Dhaka.
                    <br />
                    01755636267, 029553263
                    <br />
                    chungwah@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Xinxian Restaurant, Mirpur-01</h4>
                  <div className="text">
                    Mirpur New Market, VTCB Tower (5 th floor) 3, Main Road,
                    Mirpur-1, Dhaka 1216
                    <br />
                    01709678135, 01709678146
                    <br />
                    xinxian.mirpur1@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Shimanto Convention Centre, Rifles Square, Dhanmondi</h4>
                  <div className="text">
                    75, Bir Uttom M A Rob Road, 4th Floor, Shimanto Square
                    Market, Dhaka
                    <br />
                    01755636268, 01755636321
                    <br />
                    shimanto@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Zam Zam Convention Hall, Mirpur-01</h4>
                  <div className="text">
                    Mirpur New Market, VTCB Tower (4 th floor), 3, Main Road,
                    Mirpur-1, Dhaka 1216
                    <br />
                    01709678145, 01709678146
                    <br />
                    zamzam@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Zam Zam Convention Hall, Mirpur-11</h4>
                  <div className="text">
                    Section-7, Main Road-03, Avenue-4, Plot-1/1, Pallabi,
                    Mirpur, Dhaka.
                    <br />
                    01709678171, 01709678172
                    <br />
                    zamzam.mirpur@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>X-group Catering</h4>
                  <div className="text">
                    House No. 59/A, Sheikh Kamal Sharani, Road No. 16, Dhanmondi
                    Dhaka- 1209
                    <br />
                    01755636335, 01755636336
                    <br />
                    catering@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Four Seasons Restaurant, Mirpur-11</h4>
                  <div className="text">
                    Section: 07, Main Road-3, Avenue: 4, Plot: 1/1 (2nd Floor)
                    Pallabi, Mirpur, Dhaka-1216
                    <br />
                    01709678170, 01709678171
                    <br />
                    4season@x-grouprestaurant.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Xian Restaurant</h4>
                  <div className="text">
                    Xian Restaurant, 212 New Elephant Rd, Dhaka 1205
                    <br />
                    016545898902
                    <br />
                    xianrestaurant212@gmail.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
              <div className="location-block col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="icon-box">
                    <img src={toronto} alt="" />
                  </div>
                  <h4>Xenial Restaurant</h4>
                  <div className="text">
                    House no: 88, 365 রোড নং ২৭, Dhaka 1209
                    <br />
                    01458985868
                    <br />
                    xenialrestaurant@gmail.com
                  </div>
                  <div className="more-link">
                    <Link href="#">Book Now</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SisterConcern;
